export default __webpack_public_path__ + "static/media/img_pst_tier_platinum.ef49b2f5.svg";